(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var slider = document.getElementById('whdSlider');
    var thumb = document.getElementById('whdSliderThumb');
    var fill = document.getElementById('whdSliderFill');
    var label = document.getElementById('whdSliderLabel');
    if (!slider || !thumb) return;

    var dragging = false;
    var startX = 0;
    var thumbStartX = 0;
    var maxX = 0;
    var navigationStarted = false;

    function setMax() {
      maxX = slider.offsetWidth - thumb.offsetWidth - 8;
    }
    setMax();
    window.addEventListener('resize', setMax);

    function onDown(clientX) {
      dragging = true;
      thumb.classList.add('dragging');
      startX = clientX;
      thumbStartX = parseFloat(thumb.style.left || 4);
    }

    function onMove(clientX) {
      if (!dragging) return;
      var delta = clientX - startX;
      var newX = Math.min(Math.max(4, thumbStartX + delta), maxX);
      thumb.style.left = newX + 'px';
      fill.style.width = (newX + thumb.offsetWidth) + 'px';

      if (newX >= maxX * 0.5 && !navigationStarted) {
        startNavigation();
      }
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      thumb.classList.remove('dragging');
      var newX = parseFloat(thumb.style.left || 4);
      // Если не долетел до конца — кружок возвращается назад,
      // даже если переход уже запущен в фоне (страница вот-вот сменится)
      if (newX < maxX - 2) {
        thumb.style.left = '4px';
        fill.style.width = '0%';
      }
    }

    function startNavigation() {
      if (navigationStarted) return;
      navigationStarted = true;
      if (label) label.style.opacity = '0';

      var productUrl = slider.getAttribute('data-product-url');
      if (!productUrl || productUrl === '') {
        alert('Товар не выбран в настройках секции Wisty Hero Dark. Открой Customize → Wisty Hero Dark → поле "Товар" и выбери карту.');
        navigationStarted = false;
        if (label) label.style.opacity = '1';
        return;
      }

      setTimeout(function () {
        window.location.href = productUrl;
      }, 250);
    }

    thumb.addEventListener('mousedown', function (e) { onDown(e.clientX); });
    window.addEventListener('mousemove', function (e) { onMove(e.clientX); });
    window.addEventListener('mouseup', onUp);

    thumb.addEventListener('touchstart', function (e) { onDown(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend', onUp);
  });
})();